import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { fetchSalesforceAttributeDefs } from 'api/CustomerAPI'

const useSalesforceAttributeDefs = () => {
  const { data: salesforceAttributeDefs, error } = useQuery<any, AxiosError>({
    queryKey: ['fetchSalesforceAttributeDefs'],
    queryFn: async () => {
      const data = await fetchSalesforceAttributeDefs()
      const salesforceData = data.find(({ cardName }: any) => cardName === 'Salesforce Attributes')
      return salesforceData?.attributes
    }
  })
  return { salesforceAttributeDefs, error }
}

export default useSalesforceAttributeDefs
